import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1709e3e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Hero: require('/opt/buildhome/repo/components/hero.vue').default,About: require('/opt/buildhome/repo/components/sections/About.vue').default,Features: require('/opt/buildhome/repo/components/sections/Features.vue').default,Services: require('/opt/buildhome/repo/components/sections/Services.vue').default,ContactUs: require('/opt/buildhome/repo/components/sections/ContactUs.vue').default})
